import { warnAndNotify } from '@execonline-inc/error-reporting.private';
import { assertNever } from '@kofno/piper';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { Task } from 'taskarian';
import { callApi } from '../../../../../../../Appy';
import { currentUserStore } from '../../../../../../../CurrentUserStore';
import { findLinkT } from '../../../../../../../LinkyLinky';
import { Link } from '../../../../../../../Resource/Types';
import { searchOptionsResourceDecoder } from './Decoders';
import {
  SearchOptionsError,
  SearchOptionsResource,
  SearchOptionsState,
  loading,
  ready,
} from './Types';

export class SearchOptionsStore {
  @observable state: SearchOptionsState = {
    kind: 'waiting',
  };

  constructor() {
    makeObservable(this);
  }

  @action
  load = () => {
    switch (this.state.kind) {
      case 'waiting':
        this.state = loading();
        this.fetchOptions();
        break;
      case 'loading':
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  private fetchOptions = () => {
    Task.succeed<SearchOptionsError, ReadonlyArray<Link>>(currentUserStore.links)
      .andThen(findLinkT('adminstudio-share-learning-collections-participants-search-options'))
      .andThen(callApi(searchOptionsResourceDecoder, {}))
      .fork(
        (err) => {
          warnAndNotify('SearchOptionsStore', 'Error loading search options', {
            error: err,
          });

          runInAction(() => {
            this.state = {
              kind: 'error',
              message: 'Error loading options',
            };
          });
        },
        (resource: SearchOptionsResource) => {
          runInAction(() => {
            this.state = ready(resource);
          });
        },
      );
  };

  @computed
  get licenses() {
    switch (this.state.kind) {
      case 'ready':
        return this.state.searchOptionsResource.payload.licenses;
      case 'loading':
      case 'waiting':
      case 'error':
        return [];
      default:
        assertNever(this.state);
    }
  }
}

const searchOptionsStore = new SearchOptionsStore();

export { searchOptionsStore };
